var _radialGradient, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetsurf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2614 2614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 1431,
    cy: 2198,
    r: 2143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8f5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#000",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 16,
    strokeWidth: 88,
    d: "M887 1509a1161 1161 0 102323 0 1161 1161 0 00-2323 0z",
    transform: "matrix(1 0 0 -1 -740 2816)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2080 1121l-73-202 167-101-195-91 47-189-202 73-100-167-92 195-188-47 73 202-167 101 195 91-47 189 202-73 100 166 91-194 188 47z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M788 340l-53 202-89-18 60-219zm-96 407l-18 205-81-3 18-216zm-18 417l32 202-88 18-25-216 81-3zm82 407l81 184-78 36-84-198zm180 372l120 163-70 56-124-177zm251 332l153 156-85 42-131-144zm-909-506l177 75-21 74-152-46z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M657 1886l212 14-3 89-220-22zm421 18l208-22 11 85-215 21-3-84zm414-53l201-50 25 85-209 50zm403-117l187-85 36 74-191 92zm357-198l142-142 78 50-163 159z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetsurf);
export default __webpack_public_path__ + "static/media/netsurf.653489106cdf95e578543e6026563ae8.svg";
export { ForwardRef as ReactComponent };